<template>
  <div class="home">
    <Navbar />
    <!-- <Sidenav/> -->

    <div class="kovatek-width"></div>
    <div class="home-img">
      <div class="human-im container-fluid">
        <div class="row pt-5 pb-4">
          <div class="col-sm-0 col-md-1 col-lg-1"></div>
          <div class="col-sm-12 col-md-7 col-lg-5 mt-5 pt-md-5">
            <h3
              class="pt-5 ml-sm-5 ml-4 text-left kovatek-text font-weight-bold very-bold1"
            >
              Hire Africa’s Top Software Engineers & Collaborate Easily
            </h3>
            <p
              class="mt-3 ml-sm-5 ml-4 text-left text-white font-size2 font-weight-light"
            >
              We provide developers that are; Fully Vetted, Continuously
              Reviewed, & Rated Freelancers
            </p>
          </div>
          <div class="col-sm-12 col-md-4 col-lg-6"></div>
        </div>
        <div class="row">
          <div class="col-sm-0 col-md-1 col-lg-1"></div>
          <div class="col-sm-12 col-md-9 col-lg-7">
            <div class="text-left ctrl-vetted-text banner-add-margin ml-4 mb-5">
              <router-link to="/hire">
                <button
                  class="styled-btn btn-dev-signup mt-3 mx-3 px-4 py-2 ctrl-vetted-text text-uppercase font-weight-bold"
                >
                  Hire Developers
                </button>
              </router-link>
              <router-link to="/register/freelancer">
                <button
                  class="styled-btn btn-findjobs mt-3 mx-3 px-4 py-2 ctrl-vetted-text text-uppercase font-weight-bold"
                >
                  Join as a developer
                </button>
              </router-link>
            </div>
          </div>
          <div class="col-sm-12 col-md-3 col-lg-5"></div>
        </div>
      </div>
    </div>

    <!-- Developers Available -->
    <div class="my-5 py-5 kovatek-width">
      <h2
        class="px-4 font-weight-bolder kovatek-text text-capitalize title-size"
      >
        Find top talent for various software services
      </h2>
      <div class="m-auto container-fluid">
        <!-- <div class="d-flex justify-content-around flex-wrap"> -->
        <div class="row services-width m-auto">
          <div class="col-6 col-sm-6 col-md-3 mx-auto w-90 mt-4">
            <router-link to="/dev-services/mobile-app">
              <div class="col-12 available-devs ctrl-shadow m-auto p-0">
                <img
                  class="devs-skills-img mt-3 pt-3"
                  src="../assets/KOVATEK/PNGss/mobile-app.png"
                />
                <h6 class="py-3 kovatek-text ctrl-size1 font-weight-bold">
                  Mobile App
                </h6>
              </div>
            </router-link>
          </div>

          <div class="col-6 col-sm-6 col-md-3 mx-auto w-90 mt-4">
            <router-link to="/dev-services/blockchain">
              <div class="col-12 available-devs ctrl-shadow m-auto p-0">
                <img
                  class="devs-skills-img mt-3 pt-3"
                  src="../assets/KOVATEK/PNGss/blockchain.png"
                />
                <h6 class="py-3 kovatek-text ctrl-size1 font-weight-bold">
                  Blockchain
                </h6>
              </div>
            </router-link>
          </div>

          <div class="col-6 col-sm-6 col-md-3 mx-auto w-90 mt-4">
            <router-link to="/dev-services/artificial-intelligence">
              <div class="col-12 available-devs ctrl-shadow m-auto p-0">
                <img
                  class="devs-skills-img mt-3 pt-3"
                  src="../assets/KOVATEK/PNGss/AI.png"
                />
                <h6 class="py-3 kovatek-text ctrl-size1 font-weight-bold">
                  A.I
                </h6>
              </div>
            </router-link>
          </div>

          <div class="col-6 col-sm-6 col-md-3 mx-auto w-90 mt-4">
            <router-link to="/dev-services/web-app">
              <div class="col-12 available-devs ctrl-shadow m-auto p-0">
                <img
                  class="devs-skills-img mt-3 pt-3"
                  src="../assets/KOVATEK/PNGss/webapp.png"
                />
                <h6 class="py-3 kovatek-text ctrl-size1 font-weight-bold">
                  Web Application
                </h6>
              </div>
            </router-link>
          </div>

          <div class="col-6 col-sm-6 col-md-3 mx-auto w-90 mt-4">
            <router-link to="/dev-services/ui-ux">
              <div class="col-12 available-devs ctrl-shadow m-auto p-0">
                <img
                  class="devs-skills-img mt-3 pt-3"
                  src="../assets/KOVATEK/PNGss/ui-ux.png"
                />
                <h6 class="py-3 kovatek-text ctrl-size1 font-weight-bold">
                  UI/UX Design
                </h6>
              </div>
            </router-link>
          </div>

          <div class="col-6 col-sm-6 col-md-3 mx-auto w-90 mt-4">
            <router-link to="/dev-services/cyber-security">
              <div class="col-12 available-devs ctrl-shadow m-auto p-0">
                <img
                  class="devs-skills-img mt-3 pt-3"
                  src="../assets/KOVATEK/PNGss/cyber-security.png"
                />
                <h6 class="py-3 kovatek-text ctrl-size1 font-weight-bold">
                  CyberSecurity
                </h6>
              </div>
            </router-link>
          </div>

          <div class="col-6 col-sm-6 col-md-3 mx-auto w-90 mt-4">
            <router-link to="/dev-services/data-engineering">
              <div class="col-12 available-devs ctrl-shadow m-auto p-0">
                <img
                  class="devs-skills-img mt-3 pt-3"
                  src="../assets/KOVATEK/PNGss/data-eng.png"
                />
                <h6 class="py-3 kovatek-text ctrl-size1 font-weight-bold">
                  Data Engineering
                </h6>
              </div>
            </router-link>
          </div>

          <div class="col-6 col-sm-6 col-md-3 mx-auto w-90 mt-4">
            <router-link to="/dev-services/devops">
              <div class="col-12 available-devs ctrl-shadow m-auto p-0">
                <img
                  class="devs-skills-img mt-3 pt-3"
                  src="../assets/KOVATEK/PNGss/devops.png"
                />
                <h6 class="py-3 kovatek-text ctrl-size1 font-weight-bold">
                  DevOps
                </h6>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="bg-light mt-5 py-5">
        <h2 class="px-4 font-weight-bold">Hire Qualified Developers with Blockchain and A.I Development Experience Expertise</h2>
      <div class="row p-4">
        <div class="col-md-12 col-lg-4 my-2">
          <h6 class="px-3 font-weight-bold mt-4">Skill proven developers to scale your product development. </h6>
        </div>
        <div class="col-md-12 col-lg-8 my-2">
          <div class="row mx-3 p-3 border rounded bg-white">
            <div class="col-sm-12 col-md-6 my-3">
              <div class="add-kovatek-color mx-auto mb-2"></div>
              <h6 class="px-3 font-weight-bold">Long term contract</h6>
              <p class="px-3"> Need an expert for your long term contract</p>
              <button class="btn btn-kovatek mt-2 text-uppercase">Get Started</button>
            </div>
            <div class="col-sm-12 col-md-6 my-3">
              <div class="add-kovatek-color mx-auto mb-2"></div>
              <h6 class="px-3 font-weight-bold">Short term contract</h6>
              <p class="px-3"> Need an expert for your short term contract</p>
              <button class="btn btn-kovatek mt-2 text-uppercase">Get Started</button>
            </div>
          </div>
        </div>
      </div>
    </div> -->

    <!-- Why Choose TalentAlt -->
    <div class="my-5 pt-5 ctrl-choose mx-auto container-fluid kovatek-width ">
      <h2
        class="px-4 font-weight-bolder kovatek-text text-capitalize title-size"
      >
        Why Choose TalentAlt
      </h2>
      <div class="row p-4">
        <div class="col-sm-12 col-md-4 my-2">
          <div class="w-75 ctrl-text-align m-auto">
            <img
              src="../assets/KOVATEK/svg-embed/vetted-for-you.svg"
              class="w-25 mb-3"
              alt=""
            />
            <h5 class="kovatek-text ctrl-size font-weight-bold mb-3">
              Fully vetted for you
            </h5>
            <p class="font-weight-light">
              Ensuring quality performance and delivery is our priority. At
              TalentAlt we make sure our developers have the right expertise
              needed for your product development.
            </p>
          </div>
        </div>
        <div class="col-sm-12 col-md-4 my-2">
          <div class="w-75 ctrl-text-align m-auto">
            <img
              src="../assets/KOVATEK/svg-embed/software-talent.svg"
              class="w-25 mb-3"
              alt=""
            />
            <h5 class="kovatek-text ctrl-size font-weight-bold mb-3">
              Software talents that matches your need
            </h5>
            <p class="font-weight-light">
              TalentAlt provides elite workforce and freelancers for your
              product development covering advanced software development
              applications.
            </p>
          </div>
        </div>
        <div class="col-sm-12 col-md-4 my-2">
          <div class="w-75 ctrl-text-align m-auto">
            <img
              src="../assets/KOVATEK/svg-embed/budget-1.svg"
              class="w-25 mb-3"
              alt=""
            />
            <h5 class="kovatek-text ctrl-size font-weight-bold mb-3">
              At considerable cost
            </h5>
            <p class="font-weight-light">
              A budget-fit developers workforce for your project development.
              Tell us your project and we take it from there
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- How it works -->
    <div class="py-5 bg-light container-fluid">
      <h2
        class="px-4 mb-5 mt-4 font-weight-bolder kovatek-text text-capitalize title-size"
      >
        How TalentAlt Works
      </h2>
      <div class="row ctrl-works m-auto kovatek-width">
        <div class="col-6 col-sm-6 col-md-3 my-2">
          <div class="w-75 text-left m-auto">
            <img
              src="../assets/KOVATEK/svg-embed/1.svg"
              class="w-25 ctrl-works-img mb-3"
              alt=""
            />
            <h5 class="kovatek-text ctrl-size font-weight-bold mb-3">
              Post a project
            </h5>
            <p class="font-weight-light ctrl-size2">
              Provide project information. Your project details helps the right
              talent to bid for your project task, and also help us suggest to
              you talent that matches your project field.
            </p>
          </div>
        </div>
        <div class="col-6 col-sm-6 col-md-3 my-2">
          <div class="w-75 text-left m-auto">
            <img
              src="../assets/KOVATEK/svg-embed/2.svg"
              class="w-25 ctrl-works-img mb-3"
              alt=""
            />
            <h5 class="kovatek-text ctrl-size font-weight-bold mb-3">
              Hire Developers
            </h5>
            <p class="font-weight-light ctrl-size2">
              Developers that meet your product requirement specifications will
              bid and/or assign for your project task. You review, approve and
              hire.
            </p>
          </div>
        </div>
        <div class="col-6 col-sm-6 col-md-3 my-2">
          <div class="w-75 text-left m-auto">
            <img
              src="../assets/KOVATEK/svg-embed/3.svg"
              class="w-25 ctrl-works-img mb-3"
              alt=""
            />
            <h5 class="kovatek-text ctrl-size font-weight-bold mb-3">
              Collaborate and Scale
            </h5>
            <p class="font-weight-light ctrl-size2">
              Hire all your developers and use TalentAlt project board to track
              your project activities. Your product development is enriched with
              TalentAlt management assistance.
            </p>
          </div>
        </div>
        <div class="col-6 col-sm-6 col-md-3 my-2">
          <div class="w-75 text-left m-auto">
            <img
              src="../assets/KOVATEK/svg-embed/4.svg"
              class="w-25 ctrl-works-img mb-3"
              alt=""
            />
            <h5 class="kovatek-text ctrl-size font-weight-bold mb-3">
              Easy Payment
            </h5>
            <p class="font-weight-light ctrl-size2">
              Fund your project account and initiate payment either based on
              milestone goals you set or at a fixed-price on completion to your
              developer team, only when you are 100% satisfied.
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class=" pb-4 bg-light">
      <router-link to="/how-it-works" class="kova-text">
        <a class="font-italic text-underlined">See more >></a>
      </router-link>
    </div>

    <!-- developers based on plans -->
    <div class="my-4 py-5 mx-auto plans container-fluid kovatek-width">
      <h2
        class="px-4 mb-5 mt-4 font-weight-bolder kovatek-text text-capitalize title-size"
      >
        Hire Developers Based on plan
      </h2>
      <div class="plans-bg-img py-4 px-md-4">
        <div class="row py-4 px-md-4">
          <div class="col-sm-12 col-md-7">
            <div class="row px-4 kovatek-width">
              <div class="col-6 text-left mt-4 pl-4">
                <div class="green-box mb-3"></div>
                <h6
                  class="font-weight-bold text-white text-capitalize ctrl-size3"
                >
                  long term project
                </h6>
                <p
                  class="mt-3 text-white font-weight-lighter font-italic ctrl-size2"
                >
                  Expand your team with a skilled resource overtime.
                </p>
              </div>
              <div class="col-6 text-left mt-4 pl-4">
                <div class="green-box mb-3"></div>
                <h6
                  class="font-weight-bold text-white text-capitalize ctrl-size3"
                >
                  short time contract
                </h6>
                <p
                  class="mt-3 text-white font-weight-lighter font-italic ctrl-size2"
                >
                  Build a pool of diverse experts for one-off tasks.
                </p>
              </div>
            </div>
            <div>
              <!-- <router-link to="/hire">
                <button class="styled-btn long-term mt-3">Long Term</button>
              </router-link> -->
              <a-dropdown>
                <button class="ant-dropdown-link styled-btn long-term mt-3">
                  Long Term <a-icon type="down" />
                </button>
                <a-menu slot="overlay" class="selected-bg">
                  <a-menu-item>
                    <a
                      href="javascript:;"
                      class="text-center font-weight-bold selected-bg select-bg"
                      >Long Term</a
                    >
                  </a-menu-item>
                  <a-menu-item>
                    <a
                      href="javascript:;"
                      class="text-center font-weight-bold selected-bg select-bg"
                      >Short Term</a
                    >
                  </a-menu-item>
                </a-menu>
              </a-dropdown>
              <!-- <a-select
                labelInValue
                :defaultValue="{ key: 'long' }"
                style="width: 240px;"
                class="plan-select"
                >
              <a-select-option value="long" class="select-bg">Long Term</a-select-option>
              <a-select-option value="short">Short Term</a-select-option>
            </a-select> -->
            </div>
            <div>
              <router-link to="/hire">
                <button
                  class="styled-btn get-started font-weight-bold font-italic text-uppercase mt-3 mb-5"
                >
                  get started
                </button>
              </router-link>
            </div>
          </div>
          <div class="col-sm-12 col-md-5"></div>
        </div>
      </div>
    </div>

    <!-- Top rated Developers -->
    <div class="developers kovatek-width">
      <h2
        class="px-4 mb-5 mt-5 font-weight-bolder kovatek-text text-capitalize title-size"
      >
        Top Rated Developers
      </h2>

      <div class="top-devs m-auto">
        <div class="px-sm-4 px-lg-4 mx-auto my-5 pb-4 container-fluid">
          <div class="row">
            <div class="col-sm-12 col-md-6 col-lg-3 my-3">
              <TopRatedDev
                name="Mike. P"
                image="mike.png"
                specialization="Back-end Developer"
                charge="30"
                location="Lagos, Nigeria"
                :skills="['PHP', 'Nodejs', 'Go']"
                level="senior"
                rating="9.1"
                reviews="43"
              />
            </div>
            <div class="col-sm-12 col-md-6 col-lg-3 my-3">
              <TopRatedDev
                name="Johnson. K"
                image="developer-1.png"
                specialization="Web Developer"
                charge="25"
                location="Lagos, Nigeria"
                :skills="['Django', 'Flask', 'Rails']"
                level="intermediate"
                rating="9.5"
                reviews="56"
              />
            </div>
            <div class="col-sm-12 col-md-6 col-lg-3 my-3">
              <TopRatedDev
                name="Adara. W"
                image="developer-2.jpeg"
                specialization="Front-end Developer"
                charge="18"
                location="Ogun, Nigeria"
                :skills="['Reactjs', 'Nodejs', 'Go']"
                level="intermediate"
                rating="8.7"
                reviews="73"
              />
            </div>
            <div class="col-sm-12 col-md-6 col-lg-3 my-3">
              <TopRatedDev
                name="Idirs. A"
                image="developer-3.png"
                specialization="Full Stack Developer"
                charge="32"
                location="Ibadan, Nigeria"
                :skills="['PHP', 'Python', 'Java']"
                level="senior"
                rating="9.0"
                reviews="20"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="kovatek-text">
        <a class="font-italic text-underlined">Explore >></a>
      </div>
    </div>

    <div class="fully-vetted bg-light py-5 mt-4">
      <h2
        class="px-4 mb-5 mt-5 font-weight-bolder kovatek-text text-capitalize title-size"
      >
        we have fully vetted freelancers for your...
      </h2>
      <div class="vetted m-auto container-fluid">
        <div class="row kovatek-width mx-auto">
          <div class="col-lg-6 px-0 my-4">
            <div class="row bg-white py-md-4 m-auto ctrl-shadow can-help-h">
              <div class="col-sm-12 col-md-6 py-md-4">
                <img
                  src="../assets/KOVATEK/svg-embed/Image -2.svg"
                  class="icon-width"
                />
              </div>
              <div class="col-sm-12 col-md-6 pt-md-4 mb-sm-4 px-3 text-left">
                <h5
                  class="text-uppercase ctrl-size font-weight-bold kovatek-text mt-md-4 ctrl-vetted-text"
                >
                  mvp
                </h5>
                <div class="">
                  <p class="mb-sm-3 ctrl-vetted-text kovatek-text font-italic">
                    Request developer(s) for your minimum viable product (mvp)
                    development that fit your budget? Get a quality service from
                    our top rated developers.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-6 px-0 my-4 w-100">
            <div class="row bg-white py-md-4 m-auto ctrl-shadow can-help-h">
              <div class="col-sm-12 col-md-6 py-md-4">
                <img
                  src="../assets/KOVATEK/svg-embed/Image -3.svg"
                  class="icon-width"
                />
              </div>
              <div class="col-sm-12 col-md-6 pt-md-4 mb-sm-4 px-3 text-left">
                <h5
                  class="text-uppercase ctrl-size font-weight-bold kovatek-text mt-md-4 ctrl-vetted-text"
                >
                  code review
                </h5>
                <div class="">
                  <p class="mb-sm-3 ctrl-vetted-text kovatek-text font-italic">
                    Get a senior developer to review your code base and provide
                    you with full report on code quality, security and
                    refactoring? Access pool of senior engineers on TalentAlt.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-6 px-0 my-4 w-100">
            <div class="row bg-white py-md-4 m-auto ctrl-shadow can-help-h">
              <div class="col-sm-12 col-md-6 py-md-4">
                <img
                  src="../assets/KOVATEK/svg-embed/Image -1.svg"
                  class="icon-width"
                />
              </div>
              <div class="col-sm-12 col-md-6 pt-md-4 mb-sm-4 px-3 text-left">
                <h5
                  class="text-uppercase ctrl-size font-weight-bold kovatek-text mt-md-4 ctrl-vetted-text"
                >
                  product scaling
                </h5>
                <div class="">
                  <p class="mb-sm-3 ctrl-vetted-text kovatek-text font-italic">
                    Need integrations and more user satisfaction to reach higher
                    revenue and users’ growth? Leverage on cost-cutting elite
                    workforce on TalentAlt.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-6 px-0 my-4 w-100">
            <div class="row bg-white py-md-4 m-auto ctrl-shadow can-help-h">
              <div class="col-sm-12 col-md-6 py-md-4">
                <img
                  src="../assets/KOVATEK/svg-embed/Image -4.svg"
                  class="icon-width"
                />
              </div>
              <div class="col-sm-12 col-md-6 pt-md-4 mb-sm-4 px-3 text-left">
                <h5
                  class="text-uppercase ctrl-size font-weight-bold kovatek-text mt-md-4 ctrl-vetted-text"
                >
                  research & analysis
                </h5>
                <div class="">
                  <p class="mb-sm-3 ctrl-vetted-text kovatek-text font-italic">
                    Top data engineers are available for research, review and
                    analyze data for your project growth.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="get-hired">
      <div class="hired my-5 m-auto shadow-lg container-fluid">
        <div class="row p-5">
          <div class="col-lg-6">
            <h6 class="font-weight-bolder hired-text-color text-uppercase">
              Are you an elite Developer?
            </h6>
            <h4 class="hired-text-color font-italic very-bold text-capitalize">
              Get hired at top companies
            </h4>
          </div>
          <div class="col-lg-6 p-0">
            <router-link to="/devsignup">
              <button
                class="styled-btn btn-dev-signup mt-3 mx-3 px-5 py-2 text-uppercase font-weight-bold"
              >
                Dev Sign Up
              </button>
            </router-link>
            <router-link to="/find-jobs">
              <button
                class="styled-btn btn-findjobs mt-3 mx-3 px-5 py-2 text-uppercase font-weight-bold"
              >
                Find Jobs
              </button>
            </router-link>
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
// import TopDevsSection from '@/components/TopDevsSection.vue'
import TopRatedDev from '@/components/TopRatedDev.vue';
// import DevService from '@/components/DevService.vue'

// import Sidenav from '@/components/Sidenav.vue'

export default {
  name: 'home',
  data() {
    return {
      show: false,
    };
  },
  components: {
    Navbar,
    Footer,
    // TopDevsSection,
    TopRatedDev,
    // , Sidenav
  },
  methods: {},
};
</script>

<style scoped>
.home-img {
  background: url('../assets/KOVATEK/PNGss/Mask Group 7.png'),
    url('../assets/KOVATEK/PNGss/Banner Wallpaper.png');
  background-size: cover;
  background-position: right bottom left top;
  background-repeat: no-repeat;
  width: 100%;
  height: auto;
}
.human-img {
  /* background:; */
  position: absolute;
}
.landing-font-size {
  font-size: 18px;
}
.title-size {
  font-size: 24px;
}
.ctrl-size {
  font-size: 16px;
}
.ctrl-size1 {
  font-size: 14px;
}
.btn-outline-kovatek {
  border: solid 1px #20409a;
  transition: 0.75s;
  width: 200px;
  height: 60px;
  color: #fff;
}
.btn-outline-kovatek:hover {
  background-color: #20409a;
  color: #fff;
}
.btn-kovatek {
  background-color: #fff;
  border: solid 1px #20409a;
  color: #20409a;
  width: 150px;
  height: 40px;
  transition: 0.75s;
}
.btn-kovatek:hover {
  background-color: #20409a;
  border: solid 1px #20409a;
  color: #fff;
}
.available-devs {
  height: 180px;
  width: 180px;
  border-radius: 50px;
  transition: 0.1s;
}
.available-devs:hover {
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.2);
}
.services-width {
  width: 75%;
}
.w-90 {
  width: 90%;
}
.adjust-w {
  width: 90%;
}
.add-kovatek-bg {
  background-color: #20409a;
}
.w-94 {
  width: 94%;
}
.devs-skills-img {
  height: 50%;
}
.ctrl-shadow {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}
.v-divi {
  border-right: solid 1px rgba(0, 0, 0, 0.4);
}
.kovatek-card {
  height: auto;
  /* box-shadow: 10px 10px 10px rgba(0,0,0, 0.4); */
}
.kovatek-card-img {
  width: inherit;
  height: 100%;
}
.kovatek-cont {
  width: 100%;
  height: 60%;
}
.kovatek-background {
  background-color: #20409a;
}
.kova-img {
  height: 240px;
}
.ctrl-choose {
  width: 75%;
}
.ctrl-text-align {
  text-align: left;
}
.ctrl-works {
  width: 80%;
}
.ctrl-works-img {
  height: 100px;
}
.add-kovatek-color {
  border-bottom: solid 3px #20409a;
  width: 50px;
}
.kovatek-text {
  color: #20409a;
}
.plans {
  width: 70%;
}
.plans-bg-img {
  background-image: url('../assets/KOVATEK/PNGss/World Map.png');
  width: 100%;
  background-size: cover;
  /* min-height: 400px; */
  height: auto;
}
.green-box {
  width: 15px;
  height: 15px;
  background-color: #4bb38e;
}
.styled-btn {
  color: #fff;
  border-radius: 25px;
  outline: 0;
  transition: 0.2s;
}

.long-term {
  border: solid 1px #fff;
  background: transparent;
  font-size: 12px;
  width: 240px;
  height: 35px;
}
.selected-bg {
  background-color: #20409a;
  color: #fff;
}
.select-bg:hover {
  color: #000;
  background-color: lightblue;
}
.styled-btn:hover {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.7);
}
.styled-dropdown {
  width: 240px;
  font-size: 12px;
  /* background: transparent; */
}
.get-started {
  background: linear-gradient(to right, rgb(75, 179, 142), rgb(28, 71, 152));
  border: 0;
  width: 240px;
  height: 35px;
  box-shadow: 0 0px 4px rgba(0, 0, 0, 0.3);
}
.top-devs {
  width: 85%;
}
.rmv-deco {
  list-style-type: none;
}
.icon-size {
  font-size: 16px;
}

.can-help-h {
  min-height: 250px;
  height: auto;
  width: 90%;
  border-radius: 15px;
}
.icon-width {
  width: 200px;
  height: 200px;
}
.vetted {
  width: 80%;
}
.btn-dev-signup {
  background: linear-gradient(to right, rgb(75, 179, 142), rgb(28, 71, 152));
  border: 0;
  font-size: 12px;
  box-shadow: 0 0px 4px rgba(0, 0, 0, 0.3);
}
.btn-findjobs {
  background: linear-gradient(to right, rgb(254, 151, 22), rgb(241, 100, 45));
  border: 0;
  font-size: 12px;
  box-shadow: 0 0px 4px rgba(0, 0, 0, 0.3);
}
.hired {
  background-color: #c0e4d8;
}
.hired-text-color {
  color: #141d52;
}
.very-bold {
  font-weight: 900;
  text-shadow: 2px 0;
  letter-spacing: 2px;
  font-size: 25px;
}
.very-bold1 {
  font-weight: 900;
  text-shadow: 2px 0;
  letter-spacing: 2px;
  font-size: 36px;
}
@media screen and (min-width: 992px) and (max-width: 1325px) {
  .adjust-w {
    width: 97%;
  }
  .available-devs {
    height: 180px;
    width: 180px;
  }
  .services-width {
    width: 80%;
  }
  .ctrl-choose {
    width: 80%;
  }
  .ctrl-works {
    width: 90%;
  }
  .plans {
    width: 80%;
  }
  .top-devs {
    width: 100%;
  }
  .vetted {
    width: 90%;
  }
}
@media screen and (min-width: 768px) and (max-width: 991px) {
  .adjust-w {
    width: 80%;
  }
  .match-height {
    height: auto;
  }
  .available-devs {
    height: 150px;
    width: 150px;
  }
  .services-width {
    width: 100%;
  }
  .ctrl-choose {
    width: 100%;
  }
  .ctrl-works {
    width: 100%;
  }
  .plans {
    width: 85%;
  }
  .top-devs {
    width: 80%;
  }
}
@media screen and (max-width: 767px) {
  .match-height {
    height: auto;
  }
  .ctrl-text-align {
    text-align: center;
  }
  .ctrl-works {
    width: 100%;
  }
  .plans {
    width: 100%;
  }
  .vetted {
    width: 96%;
  }
  .ctrl-vetted-text {
    text-align: center;
  }
  .text-size5 {
    text-align: center;
  }
  /* .home-img{
  background:  linear-gradient(to right, rgba(0,0,0, 0.2), rgba(0,0,0, 0.4)), url('../assets/KOVATEK/PNGss/banner-img-sm.png'), url('../assets/KOVATEK/PNGss/Banner Wallpaper.png');
  background-size: cover;
  background-position: right bottom left top;
  background-repeat: no-repeat;
  width: 100%;
  height: auto;
} */
}

@media screen and (max-width: 540px) {
  .match-height {
    height: auto;
  }
  .available-devs {
    height: 150px;
    width: 150px;
  }
  .services-width {
    width: 100%;
  }
  .ctrl-text-align {
    text-align: center;
  }
  .ctrl-works {
    width: 100%;
  }
  .ctrl-size2 {
    font-size: 12px;
  }
  .ctrl-size3 {
    font-size: 14px;
  }
  .banner-add-margin {
    margin-top: 30px;
  }
  .title-size {
    font-size: 16px;
  }
}
</style>
